import React, { useState, useEffect } from "react";
import avatarEdit from "../../assets/images/icons/avatarEdit.svg";
import avatarMessage from "../../assets/images/icons/avatarMessage.svg";
import { BASE_URL, GET_ALL_STAFF_MEMBERS_URL } from "../../env";
import { displayEnumProperty, formateDate } from "../../helper/helper";
import UserProfileUpdate from "../modals/UserProfileUpdate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProgressComponent from "../general/ProgressComponent";
import ProtectedComponent from "../../permissions/ProtectedComponent";
import { permissions } from "../../permissions/roles";
import Accordion from 'react-bootstrap/Accordion';
import {
  isSuccess,
  catchAsync,
  toastErrorMessages,
  filterRowsByProperty,
  getRecords,
} from "../../helper/helper";
import moment from "moment/moment";
import PermissionWrapper from "../../permission_advance/PermissionWrapper";

function ProfileDetail({ getUserRecord }) {
  const userLoggedInDetails = JSON.parse(localStorage.getItem('userLoggedInDetails'));
  const loggedInUserId = userLoggedInDetails?._id || "";
  const [userData, setUserData] = useState();
  console.log("🚀 ~ ProfileDetail ~ userData:", userData)
  const [editUserData, setEditUserData] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isToastProfileDetails, setIsToastProfileDetails] = useState(false);
  const [isShowModel, setIsShowModel] = useState(false);
  const apiQuery = {
    sortproperty: "createdAt",
    sortorder: -1,
    offset: 0,
    query: {
      critarion: { _id: getUserRecord?._id },
    },
  };

  const processFetchRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsToastProfileDetails(true);
      toastErrorMessages(toast?.error, data?.message, "", 1000, 1000);
    } else if (method === "get" && data?.status === isSuccess) {
      const staffMember = data?.data?.staffMembers[0];
      setUserData(staffMember);
      setIsLoading(false);
    }
  };
  const fetchAllRecords = catchAsync(async (req, res) => {
    const response = await getRecords(GET_ALL_STAFF_MEMBERS_URL, apiQuery);
    processFetchRecords("get", response);
  });

  const handleIsShowModel = () => {
    fetchAllRecords();
    setIsShowModel(true);
  };
  const handleCloseModal = () => {
    setIsShowModel(false);
  };

  useEffect(() => {
    fetchAllRecords();
  }, []);

  useEffect(() => {
    if (loggedInUserId === userData?._id) {
      setEditUserData(true)
    } else {
      setEditUserData(false)
    }
  })

  const staffDesignation = displayEnumProperty("staffDesignation", userData?.staffDesignation);
  return (
    <>
      {isLoading ? (
        <ProgressComponent />
      ) : (
        <div className="profileDetailBlock">
          <div className="userAvatar">
            <img
              src={BASE_URL + userData?.user?.profile_picture_url}
              alt={"profilePic"}
            />
            <div className="avatarAction">
              <PermissionWrapper title="Staff" action="update">
                <span onClick={handleIsShowModel}>
                  <img src={avatarEdit} alt=" avatar edit" />
                </span>
              </PermissionWrapper>
              <br />
              {/* {
                userLoggedInDetails?.staffRoles[0] === "superadmin" ? (
                  
                    <span onClick={handleIsShowModel}>
                      <img src={avatarEdit} alt=" avatar edit" />
                    </span>
                  
                ) : (
                  editUserData && (
                    <span onClick={handleIsShowModel}>
                      <img src={avatarEdit} alt=" avatar edit" />
                    </span>
                  )
                )
              } */}
              {/* <span>
                <img src={avatarMessage} alt="avatar message" />
              </span> */}
            </div>
            {userData?.user?.name && (
              <h3>
                {userData?.user?.name}
                {userData?.lastName && ` ${userData?.lastName}`}
              </h3>
            )}
          </div>
          {
            userData?.allergiesStatus && (
              <div className="allergiesBlock mt-3">
                <Accordion>
                  <Accordion.Item eventKey="0" className="allergy-accordion">
                    <Accordion.Header>Allergies</Accordion.Header>
                    <Accordion.Body>
                      <div className="dataTableWrapper carePlanDataTableWrapper">
                        <ol className="m-0 p-0 ps-3">
                          {userData?.allergies?.map((allergy, index) => (
                            <li key={index}>{allergy}</li>
                          ))}
                        </ol>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            )
          }

          <div className="userDetail">
            <p>
              <small>Important Information</small>
              {userData?.importantInfo}
            </p>
            <p>
              <small>Start Date</small>
              {moment(userData?.staffWorkLoads[0]?.startDate).format("DD/MM/YYYY")} </p>
            <p>
              <small>Job Title</small>
              {userData?.jobTitle !== "" ? userData?.jobTitle : userData?.staffDesignation}
            </p>
            <p>
              <small>Manager</small>
              {userData?.managerId?.name}
            </p>
            <p>
              <small>Supervisor</small>
              {userData?.supervisorId?.staffMemberName}
            </p>
            <p>
              <small>Email</small>
              <a href={`mailto:${userData?.user?.email}`} className="greyColor">
                <small>{userData?.user?.email}</small>
              </a>
            </p>
            <p>
              <small>Contact Number</small>
              {userData?.user?.phoneNumber}
            </p>
            <p>
              <small>Address</small> {userData?.houseFlatNumber}{" "}{userData?.addressLine1}{" "}{userData?.town}{" "}{userData?.city}
            </p>
            <p>
              <small>Post Code</small> {userData?.postcode}
            </p>
            <p>
              <small>Dob</small> {moment(userData?.stafDob).format("DD/MM/YYYY")}
            </p>
            <p>
              <small>NI Number</small>
              {userData?.niNumber}
            </p>
            <p>
              <small>First Language</small>
              {userData?.firstLanguage}
            </p>
            <p>
              <small>Visa Number</small>
              {userData?.visaNumber}
            </p>
            <p>
              <small>Visa Expiry</small>
              {/* {userData?.visaExpiry} */}
              {moment(parseInt(userData?.visaExpiry)).format("DD/MM/YYYY")}
            </p>
            {
              userData?.driverFields?.isDriver && (
                <>
                  <p>
                    <small>Driving</small>
                    {userData?.driverFields?.isDriver ? "Yes" : "No"}
                  </p>
                  <p>
                    <small>Vehicle Type</small>
                    {userData?.driverFields?.vehicleType}
                  </p>
                </>
              )
            }
            <p><strong>NOK Details</strong></p>
            <p>
              <small>NOK Name</small>
              {userData?.nokName}
            </p>
            <p>
              <small>NOK Email Address</small>
              {userData?.nokEmailAddress}
            </p>
            <p>
              <small>NOK Primary Contact</small>
              {userData?.nokPrimaryContact}
            </p>
            <p>
              <small>NOK Secondary Contact</small>
              {userData?.nokSecondaryContact}
            </p>
            <p>
              <small>NOK House / Flat Number</small>
              {userData?.nokHouseFlatNumber}
            </p>
            <p>
              <small>NOK Address Line</small>
              {userData?.nokAddressLine}
            </p>
            <p>
              <small>NOK Town</small>
              {userData?.nokTown}
            </p>
            <p>
              <small>NOK City</small>
              {userData?.nokCity}
            </p>
            <p>
              <small>NOK Country</small>
              {userData?.nokCountry}
            </p>
            <p>
              <small>NOK Post Code</small>
              {userData?.nokPostCode}
            </p>

          </div>
        </div >
      )
      }
      {
        isShowModel && (
          <UserProfileUpdate
            showModal={isShowModel}
            closeModal={handleCloseModal}
            userData={userData}
            fetchAllRecords={fetchAllRecords}
          />
        )
      }
      {isToastProfileDetails && <ToastContainer />}
    </>
  );
}

export default ProfileDetail;
